/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Label } from 'react-bootstrap'
import ReactSelect from 'react-select'

import i18n from 'live/services/i18n'

import { IBowtie } from 'plugin-codaf-risk-ext-bowtie/types'
import { ISelect, ISelectBowtie } from 'plugin-codaf-risk-ext-bowtie/types/engineeringAudit'
import { Entity } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { FilterContainer, PresetsContainer, Select } from './style'

interface IProps {
    preset: ISelect
    setPreset: (k: ISelect) => void
    filterResource: ISelect
    setFilterResource: (k: ISelect) => void
    filterBowtie: ISelectBowtie
    setFilterBowtie: (k: ISelectBowtie) => void
    bowtieData: IBowtie[]
}

export const EngineeringFilters: React.FC<IProps> = ({
    preset,
    setPreset,
    filterBowtie,
    setFilterBowtie,
    filterResource,
    setFilterResource,
    bowtieData
}) => {
    const presets: ISelect[] = [
        { label: i18n('Barrier'), value: Entity.BARRIER },
        { label: i18n('Escalation Factor'), value: Entity.ESCALATION_FACTOR },
        { label: i18n('Escalation Factor Control Barrier'), value: Entity.CONTROL_BARRIER },
        { label: i18n('Threat'), value: Entity.THREAT },
        { label: i18n('Consequence'), value: Entity.CONSEQUENCE },
        { label: i18n('Top Event'), value: Entity.TOP_EVENT }
    ]
    const resources = bowtieData.map(bowtie => {
        return bowtie.asset.name
    })
    const filtredResources = [...new Set(resources)]
    const bowtie = bowtieData
        .filter(resourceFilter =>
            filterResource ? resourceFilter.asset.name === filterResource.value : resourceFilter
        )
        .map(bowtie => {
            return {
                value: bowtie.id,
                label: `${bowtie.bowtieCode} | ${bowtie.topEvent.hazard.name} | ${bowtie.topEvent.name}`
            }
        })

    useEffect(() => {
        setFilterBowtie(null)
    }, [filterResource])

    useEffect(() => {
        setPreset(null)
    }, [filterBowtie])

    return (
        <PresetsContainer>
            <div className="sidebar-title">
                <span>{i18n('CONTEXT')}</span>
            </div>
            <FilterContainer>
                <Label className="control-label filter-label">{i18n('Resource')}</Label>
                <Select
                    options={filtredResources.map(st => ({ value: st, label: st }))}
                    searchable={true}
                    clearable={false}
                    onChange={setFilterResource}
                    value={filterResource}
                    placeholder={i18n('Select...')}
                />
            </FilterContainer>
            <FilterContainer>
                <Label className="control-label filter-label">{i18n('Bowtie')}</Label>
                <Select
                    options={bowtie.map(bt => ({ value: bt.value, label: bt.label }))}
                    searchable={true}
                    clearable={false}
                    onChange={setFilterBowtie}
                    value={filterBowtie}
                    disabled={!filterResource?.value}
                    placeholder={i18n('Select...')}
                />
            </FilterContainer>
            <FilterContainer>
                <Label className="control-label filter-label">{i18n('Entity')} *</Label>
                <Select
                    options={presets.map(st => ({ value: st.value, label: st.label }))}
                    searchable={false}
                    clearable={false}
                    onChange={setPreset}
                    value={preset}
                    disabled={!filterBowtie?.value}
                    placeholder={i18n('Select...')}
                />
            </FilterContainer>
        </PresetsContainer>
    )
}
